import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import LoadingAnimation from '../../../components/LoadingAnimation';
import { getFromLocalStorage } from '../../../components/helper/authorizationHelper';
import baseURL, { postAsync } from '../../../components/helper/axiosHelper';
import { DataNotFound } from '../../../components/DataNotFound';
import { defaultImage } from '../../../constants';
const ServiceFYouCards = ({ searchData, isLoading, datanotfound }) => {
  const isActive = useSelector((state) => state.toggle.isActive);
  //const id = Number(getStorage('id'));
  const [epUserID, setEpUserID] = useState(null);
  const [isShare, setIsShare] = useState(false);
  const token = localStorage.getItem('token');
  const navigate = useNavigate();
  const searchURL = `${baseURL}/ServiceForYou/CreateServiceForYou`;
  const [selectedCard, setSelectedCard] = useState(null);

  const isLogin = () => {
    if (!token) {
      navigate('/donorLogin');
    }
  };

  useEffect(() => {
    isLogin();
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });
  }, [epUserID]);

  const handleSelect = async (e, projectId, templateName, projectTypeIdInt) => {
    try {
      const buttons = document.querySelectorAll('.selectbutton');
      buttons.forEach((button) => {
        if (button === e.target) {
          button.textContent = button.textContent === t('Select') ? t('Selected') : t('Select');
          const formSection = document.getElementById('form-section');
          if (formSection) {
            formSection.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
              inline: 'nearest',
            });
          }
        } else {
          button.textContent = t('Select');
        }
      });

      const requestData = {
        epUserID: epUserID,
        ProjectNameAR: templateName,
        ProjectNameEn: '',
        projectID: projectId,
        projectTypeIdInt,
      };
      // Hit the request with the selected ID
      await postAsync('ServiceForYou/CreateServiceForYou', requestData)
        .then((res) => {
          if (res.statusCode == 200) {
            toast.success(t('Registration successful.'));
          }
          if (res.statusCode == 422) {
            toast.warning(t('The project has already been registered; please choose a different one.'));
          }
        })
        .catch((err) => {
          console.log(t('Something went wrong, Please try again!'));
        });

      // const navigateUrl = `/ServiceFYUPRegistList?eid=${requestData.epUserID}/plink=${requestData.projectID}`;

      //navigate(navigateUrl);
      setIsShare(true);
    } catch (error) {
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  return (
    <>
      <div className="col-lg-11 mb-4  shadow-md py-6 rounded-md">
        <div className="py-2">
          <h1 className="font-bold sm:text-2xl text-center text-xl text-customgreen">{`${searchData?.length > 0 ? t('Projects') : ''}`}</h1>
        </div>
        <div
          className={`flex flex-wrap ${searchData?.length > 0 ? 'h-[500px]' : ''}  overflow-y-auto justify-center mb-4 gap-3 pb-10`}
        >
          {searchData?.map((data, index) => (
            <div
              key={index}
              className={` ${selectedCard === index ? ' scale-105 transition-transform duration-300 bg-green-50 shadow-2xl' : 'shadow-md'} block ml-4 mt-4 w-72 h-[350px] dark:bg-neutral-700 text-center shadow px-3  rounded-3xl`}
            >
              <h5 className=" p-3 text-xl tracking-wide  capitalize text-customgreen text-center">
                {isActive
                  ? data?.projectType_AR.length > 15
                    ? `${data.projectType_AR.slice(0, 15)}...`
                    : data.projectType_AR
                  : data?.projectType.length > 15
                    ? `${data.projectType.slice(0, 15)}...`
                    : data.projectType}
                {/* {isActive ? data?.projectType_AR : data?.projectType} */}
              </h5>

              {data?.file_Stream ? (
                <img
                  className="w-full h-32 rounded-t-3xl"
                  src={`data:image/jpeg;base64,${data?.file_Stream}`}
                  alt={data?.projectType}
                />
              ) : (
                <>
                  <img
                    className="w-full h-32 rounded-t-3xl"
                    variant="top"
                    src={`data:image/jpeg;base64,${defaultImage}`}
                  />
                </>
              )}

              <div className="py-6">
                <div className="flex justify-center items-center p-3 align-middle  gap-2">
                  {/* <Card.Text className="capitalize text-customgreen text-center">
                                                    {isActive ? data?.projectType_AR : data?.projectType}
                                                  </Card.Text> */}
                  {/* <Card.Text className=" text-sm font-bold tracking-tight text-gray-900">
                                                    {t('Total Cost')}:
                                                  </Card.Text>
                                                  <Card.Text
                                                    className={`ml-2 text-customorange font-bold ${isActive ? 'mr-2' : 'ml-2'}`}
                                                  >
                                                    {data?.totalCost} {t('AED')}
                                                  </Card.Text> */}
                  <h5 className="md:my-3 my-2 text-md text-center text-sm font-bold tracking-tight text-gray-900 ">
                    {' '}
                    {t('Total Cost')} <span className={isActive ? 'mr-2' : 'ml-2'}>:</span>
                    <span className={`mx-2 text-customorange font-bold ${isActive ? 'mr-2' : 'ml-2'}`}>
                      {data?.totalCost}
                    </span>
                    {t('AED')}
                  </h5>
                </div>
                <button
                  type="button"
                  name="ProjecttypeId"
                  onClick={(e) => {
                    handleSelect(e, data?.id, data?.templateName, data?.projectTypeIdInt);
                    setSelectedCard(index);
                  }}
                  className="w-full text-white selectbutton bg-customgreen hover:bg-hovergreen  font-medium rounded-full text-sm px-8 py-2.5 text-center me-1"
                >
                  {t('Select')}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {datanotfound && <DataNotFound />}
    </>
  );
};

export default ServiceFYouCards;
